module.exports = "<div id=\"pell\" class=\"pell\"></div>\r\n"